import { useEffect, useRef } from "react";

// 5 minutos, conforme solicitado para o encerramento automático de sessão.
export const IDLE_TIMEOUT = 5 * 60 * 1000;

// Eventos que contam como "o utilizador está a usar o sistema" e que,
// por isso, reiniciam o temporizador de inactividade.
const ACTIVITY_EVENTS = [
  "mousedown",
  "mousemove",
  "keydown",
  "wheel",
  "touchstart",
  "scroll",
];

/**
 * Chama `onIdle` quando o utilizador fica `timeout` ms sem interagir com a
 * página (sem mexer o rato, sem escrever, sem fazer scroll, etc.).
 *
 * Cada interacção reinicia a contagem, pelo que a sessão só termina se o
 * utilizador ficar mesmo ausente pelo período configurado.
 */
const useIdleLogout = (onIdle, { timeout = IDLE_TIMEOUT, enabled = true } = {}) => {
  const timerRef = useRef(null);
  // Guardado em ref para que alterar `onIdle` entre renders não obrigue a
  // recriar os listeners nem a reiniciar a contagem já em curso.
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    if (!enabled) return undefined;

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => onIdleRef.current?.(), timeout);
    };

    ACTIVITY_EVENTS.forEach((eventName) =>
      window.addEventListener(eventName, resetTimer, { passive: true })
    );
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach((eventName) =>
        window.removeEventListener(eventName, resetTimer)
      );
    };
  }, [enabled, timeout]);
};

export default useIdleLogout;
